<template>
  <div>
    <div class="modal is-active" v-show="showAddEditBillingModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ billingPaymentToSave.billingPaymentId ? "Edit" : "Add" }} Billing
            Payment
          </p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column is-4">
              <div class="field">
                <label class="label is-small">Amount</label>
                <div class="control">
                  <input
                    type="number"
                    v-model="billingPaymentToSave.amount"
                    placeholder="Enter amount"
                    class="input is-small"
                  />
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label is-small">Withholding Tax</label>
                <div class="control">
                  <input
                    type="number"
                    v-model="billingPaymentToSave.withholdingTax"
                    placeholder="Enter amount"
                    class="input is-small"
                  />
                </div>
              </div>
            </div>
            <div class="column is-3">
              <div class="field">
                <label class="label is-small">Date of Payment</label>
                <div class="control">
                  <input
                    type="date"
                    v-model="billingPaymentToSave.dateOfPayment"
                    class="input is-small"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <label class="label is-small">Note</label>
                <div class="control">
                  <textarea
                    type="text"
                    v-model="billingPaymentToSave.note"
                    class="input is-small"
                    maxlength="500"
                    style="margin: 0px; height: 64px;"
                  />
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label is-small">Payment Method</label>
                <div class="select is-small">
                  <select v-model="billingPaymentToSave.paymentMethod">
                    <option value="0">CASH</option>
                    <option value="1">CHECK</option>
                    <option value="2">CREDIT/DEBIT CARD</option>
                    <option value="3">BANK DEPOSIT</option>
                    <option value="4"
                      >WIRE TRANSFER (e.g. Gcash, PayMaya etc.)</option
                    >
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <label class="label is-small">Add Proof of Payment</label>
                <div class="control">
                  <input
                    ref="inputFile"
                    type="file"
                    class="input is-small"
                    multiple
                    @change="fileChange($event.target.files)"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <button :class="buttonSave" @click="savePayment">
            Save Payment
          </button>
          <button class="button is-small" @click="closeModal">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import moment from "moment";

const appToast = new AppToast();
const appButton = new AppButton();

export default {
  data() {
    return {
      files: new FormData(),
      billingPaymentToSave: {
        billingPaymentId: 0,
        billingId: 0,
        withholdingTax: 0,
        amount: 0,
        dateOfPayment: null,
        paymentMethod: null,
        note: ""
      },
      buttonSave: appButton.isLoadingSuccess(false)
    };
  },
  computed: {
    ...mapState("billing", {
      showAddEditBillingModal: state => state.showAddEditBillingModal,
      billingPayment: state => state.billingPayment
    })
  },
  methods: {
    ...mapActions("billing", ["openAddEditBillingModal", "getPaginatedData"]),
    deleteData() {},
    fileChange(fileList) {
      for (let i = 0; i < fileList.length; i++) {
        this.files.append("files", fileList[i], fileList[i].name);
      }
    },
    savePayment() {
      this.billingPaymentToSave.billingId = this.$route.params.billingId;

      if (!this.billingPaymentToSave.billingPaymentId)
        this.billingPaymentToSave.billingPaymentId = 0;
      if (!this.billingPaymentToSave.dateOfPayment)
        this.billingPaymentToSave.billingPaymentId = new Date().getDate();
      if (!this.billingPaymentToSave.paymentMethod)
        this.billingPaymentToSave.paymentMethod = null;
      if (!this.billingPaymentToSave.withholdingTax)
        this.billingPaymentToSave.withholdingTax = 0;
      if (!this.billingPaymentToSave.note) this.billingPaymentToSave.note = "";

      if (!this.billingPaymentToSave.amount) {
        appToast.danger("Amount is empty");
        return false;
      }

      if (!this.billingPaymentToSave.paymentMethod) {
        appToast.danger("Payment method is empty");
        return false;
      }

      this.buttonSave = appButton.isLoadingSuccess(true);
      this.files.append(
        "billingPaymentInfo",
        JSON.stringify(this.billingPaymentToSave)
      );
      axios
        .post(`api/billings/save-payment/`, this.files)
        .then(response => {
          appToast.success(response.data);
          this.buttonSave = appButton.isLoadingSuccess(false);
          this.default();
        })
        .catch(error => {
          if (error.response) {
            appToast.danger(error.response.data);
          }
          this.buttonSave = appButton.isLoadingSuccess(false);
        });
    },
    closeModal() {
      this.default();
    },
    default() {
      this.openAddEditBillingModal({
        showAddEditBillingModal: false
      });
      this.billingPaymentToSave = {
        billingPaymentId: 0,
        billingId: 0,
        amount: 0,
        withholdingTax: 0,
        dateOfPayment: null,
        note: ""
      };
      this.$refs.inputFile.value = null;
      this.$refs.inputFile.value = "";
      this.files = new FormData();
    }
  },
  watch: {
    billingPayment() {
      if (this.billingPayment) {
        this.billingPaymentToSave = {
          billingPaymentId: this.billingPayment.billingPaymentId,
          billingId: this.billingPayment.billingId,
          amount: this.billingPayment.amount,
          withholdingTax: this.billingPayment.withholdingTax,
          dateOfPayment: moment(this.billingPayment.dateOfPayment).format(
            "YYYY-MM-DD"
          ),
          paymentMethod: this.billingPayment.paymentMethod,
          note: this.billingPayment.note
        };
      }
    }
  }
};
</script>
